var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.preview.inIframe)?_c('div',{staticClass:"module"},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.code}}),_c('div',{staticClass:"text"},[_vm._v("当前为效果图，请配置")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }